<template>
  <div id="footer_m">
    <router-link class="left" to="./Index"><img src="../assets/img/cover_logo.png" alt=""></router-link>
    <div class="right">
      <h3>Acoustic Solution Provider Of Sustainability And Innovation</h3>
      <p>Guangdong Brotex Acoustic Technology Co.,Ltd</p>
      <div class="sharebox">
        <i class="iconfont icon-facebook" @click="goPage(1)"></i>
        <i class="iconfont icon-changyonglogo44" @click="goPage(2)"></i>
        <i class="iconfont icon-shejiaotubiao-14" @click="goPage(3)"></i>
        <i class="iconfont icon-ins" @click="goPage(4)"></i>
      </div>
    </div>

    <div id="rightfloat" v-if="navIndex!=3 && navIndex!=5">
      <div class="email" :class="showform?'show':''">
        <div class="imgbg" @click="showform=!showform"></div>
        <!--        <img src="../assets/img/float_icon1.png" alt="float_icon1.png">-->
        <div class="msgbox">
          <div class="input_line">
            <div class="inputbox">
              <input class="form_input" placeholder="Name" type="text" v-model="form.name">
            </div>
          </div>
          <div class="input_line">
            <div class="inputbox">
              <input class="form_input" placeholder="Email" type="email" v-model="form.email">
            </div>
          </div>
          <div class="input_line areabox">
            <textarea class="form_area" placeholder="Message" name="" id="" cols="30" rows="5" v-model="form.message"></textarea>
          </div>
          <div class="mainBtn1 hbutton_isi" @click="submit()" v-loading="loading">SEND</div>
        </div>
      </div>
    </div>
    <div class="gotop" @click="backToTop()" :style="{zIndex:(showform==true?'998':'999')}"><img src="../assets/img/float_icon2.png" alt=""></div>
  </div>

</template>

<script>
// import wave3d2 from "../components/wave3d2";
import * as $request from "../api";
export default {
  name: 'Footer_m',
  props: {
    far_nav:Number,
    visibilityHeight: {
      type: Number,
      default: 400
    },
    backPosition: {
      type: Number,
      default: 0
    },

  },
  components:{
    // wave3d2
  },
  data(){
    return{
      loading:false,
      form:{
        name:'',
        email:'',
        message:'',
      },
      interval: null,
      isMoving: false,
      navIndex: 0,
      showform:false,
    }
  },
  watch: {
    far_nav(newvalue){
      this.navIndex=newvalue
      // console.log(this.navIndex)
    }
  },
  methods: {
  goPage(num){
      if(num==1){
        window.open('https://www.facebook.com/brotexacoustic')
      }else if(num==2){
        window.open('https://twitter.com/')
      }else if(num==3){
        window.open('https://www.linkedin.com/')
      }else if(num==4){
        window.open('https://www.instagram.com/')
      }
    },
    submit(){
      if(this.form.name!='' && this.form.email!='' && this.form.message!=''){
        if(this.loading==false){
          this.loading=true
          $request.postForm(this.form).then(res=>{
            this.loading=false
            if(res.code==200){
              this.$message.success('Successed!');
              this.$google()
            }else{
              this.$message.error('Failed!');
            }
          })
        }
      }else{
        // this.loading=false
        this.$message.warning('The form can\'t be empty!');
      }
    },
    routerLink(index, path) {
      // 点击哪个路由就赋值给自定义的下下标
      // console.log(index)
      this.$emit('getnav',index)
      // 路由跳转
      this.$router.push(path)
    },
    backToTop() {
      if (this.isMoving) return
      const start = window.pageYOffset
      let i = 0
      this.isMoving = true
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition)
          clearInterval(this.interval)
          this.isMoving = false
        } else {
          window.scrollTo(0, next)
        }
        i++
      }, 16.7)
    },
    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b
      return -c / 2 * (--t * (t - 2) - 1) + b
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(()=>{
      window.addEventListener('scroll',function(){
        let tou = document.querySelector('.gotop');
        tou.classList.toggle("show",window.scrollY>500);
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
}
</script>
<style scoped>
#rightfloat,.gotop{position: fixed;right: 0%;display: flex;flex-direction: column;z-index: 999;}
#rightfloat{top: 50%;display: none;}
.gotop{bottom: 35%;cursor: pointer;transform: translate(100px,0);transition: .6s;box-shadow: 0 0 20px 2px rgba(0,0,0,.08);}
.gotop.show{display: flex;transform: translate(0,0);}
#rightfloat .imgbg{cursor: pointer;width: .4rem;height: .4rem;box-shadow: 0 0 20px 2px rgba(0,0,0,.08);}
#rightfloat .email{display: flex;position: absolute;top: 100%;right: -60vw;transition: .6s;}
/*#rightfloat .email:hover{transform: translate(-60vw,0)}*/
#rightfloat .email.show{transform: translate(-60vw,0);}
#rightfloat .email .msgbox{width: 60vw;margin-left: 0px;background: white;box-shadow: 0 0 20px 2px rgba(0,0,0,.08);padding: .15rem;box-sizing: border-box;}
#rightfloat .email .msgbox .inputbox{width: 100%;}
#rightfloat .email .mainbtn1{margin:0;font-size: 16px;transform: scale(.8);transform-origin: 0 100%;cursor: pointer;}
#rightfloat .email .mainbtn1 span:after{top: -2px;}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#footer_m{padding: .4rem .1rem;background: @main-c4;position: relative;color: white;display: flex;justify-content: space-between;align-items: center;flex-direction: column;z-index: 100;
  //.wave3d{position: absolute;right: 0%;top: 0;width: 70%;height: 100%;z-index: -1;}
  .left{width: 25%;
    img{width: 100%;}
  }
  .right{text-align: center;
    h3{font-size: .15rem;margin: .1rem 0;}
    p{font: .13rem "MyriadPro Regular";}
    .sharebox{margin-top: .2rem;
      i{margin: .1rem;font-size: .14rem;cursor: pointer;color: @main-c1;}
    }
  }
  .gotop{width: .4rem;height: .4rem;align-items: center;justify-content: center;background: @main-c1;
    i{color: white;font-weight: bold;font-size: 22px;}
    img{width: 45%;}
  }
  #rightfloat{
    .imgbg{background:url('../assets/img/float_icon1.png')no-repeat 50% 50%/.18rem .16rem @main-c1;transition: .6s;}
    .email{
      .inputbox,.areabox{display: flex;flex-direction: column;font: .12rem/.16rem Ubuntu-R;color: #6D6D6D;}
      .mainBtn1{transform: scale(1);transform-origin: 0 50%;}
      &:hover{
        .imgbg{background-color: @main-c1;}
      }
    }
  }
}
</style>
